import { logUsage } from 'owa-analytics';
import type { FluidLoadSource, FluidLoadOwaScenario, FluidOwaSource } from 'owa-fluid-validations';

export default function fluidComponentError(
    owaScenario: FluidLoadOwaScenario,
    owaSource: FluidOwaSource,
    source: FluidLoadSource,
    error: Error
) {
    const errorString = typeof error === 'string' ? error : getFluidErrorString(error);
    logUsage(
        'FluidComponentError',
        {
            OwaScenario_1: owaScenario,
            ComponentSource_2: source,
            Error_3: errorString,
            OwaSource_4: owaSource,
        },
        { isCore: true }
    );
}

function getFluidErrorString(error: any): string | null {
    if (!error) {
        return null;
    }
    const fluidError = {
        error: error.toString(),
        message: error.message ?? '',
        stack: error.stack ?? '',
    };

    return JSON.stringify(fluidError);
}
